import { Component, OnInit, OnChanges, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';

import { ChartDataSets } from 'chart.js';
import { UiService } from '@services/ui.service';
import { FormatService } from '@services/format.service';

import { MonitoringResultData  } from '@classes/monitoring/monitoring-result-data' ;
import { MonitoringResultGraph } from '@classes/monitoring/monitoring-result-graph';

@Component({
  selector: 'app-monitoring-graph-pie',
  templateUrl: './monitoring-graph-pie.component.html',
  styleUrls: ['./monitoring-graph-pie.component.scss']
})
export class MonitoringGraphPieComponent implements OnInit, OnChanges, AfterViewInit {

    @Input() graph: MonitoringResultGraph;

    labels: string[];
    values: number[];

    public colors: any[] = null;

    public readonly option = {
        animation: {
            animateRotate: true,
            animateScale: false
        },
        tooltips: {
            callbacks: {
                label: (tooltipItem: any, data: any) => {
                    const dataset: ChartDataSets = data.datasets[tooltipItem.datasetIndex];
                    const dataValues: number[] = <number[]>dataset.data;
                    const value: number = dataValues[tooltipItem.index];
                    const total: number = dataValues.reduce((tot, val) => tot + val, 0);
                    return `${data.labels[tooltipItem.index]}: ${this.formatSrv.formatPercent(value / total)}`;
                }
            },
            bodyFontSize : 12,
        },
        legend: {
            position: 'right',
            labels: {
                generateLabels: (chart: any) => {
                    return chart.data.labels.map((label: string, i: number) => {
                        const value: number = chart.data.datasets[0].data[i] as number;
                        const valueString = this.graph.format === 'percent'
                            ? this.formatSrv.formatPercent(value)
                            : "" + value;
                        const text = `${label}: ${(valueString)}`;
                        return {
                            text: text,
                            fillStyle: chart.data.datasets[0].backgroundColor[i],
                            hidden: !chart.isDatasetVisible(0),
                            lineCap: chart.data.datasets[0].borderCapStyle,
                            lineDash: chart.data.datasets[0].borderDash,
                            lineDashOffset: chart.data.datasets[0].borderDashOffset,
                            lineJoin: chart.data.datasets[0].borderJoinStyle,
                            lineWidth: chart.data.datasets[0].borderWidth,
                            strokeStyle: chart.data.datasets[0].borderColor[i],
                            pointStyle: chart.data.datasets[0].pointStyle
                        };
                    });
                },
                fontSize: 12
            },
            onClick: function(e: any, legendItem: any) {
                const index = legendItem.datasetIndex;
                const ci = this.chart;
                const alreadyHidden = (ci.getDatasetMeta(index).hidden === null)
                        ? false : ci.getDatasetMeta(index).hidden;

                ci.data.datasets.forEach(function(e, i) {
                    const meta = ci.getDatasetMeta(i);

                    if (i !== index) {
                    if (!alreadyHidden) {
                        meta.hidden = meta.hidden === null ? !meta.hidden : null;
                    } else if (meta.hidden === null) {
                        meta.hidden = true;
                    }
                    } else if (i === index) {
                    meta.hidden = null;
                    }
                });

                ci.update();
            }
        }
    };

    private readonly _colors: any[] = [
        {
            backgroundColor: [
                '#af1e3c',
                '#faafa0',
                '#dc1e5f',
                '#ffdae1',
                '#f03241',
                '#979faa',
                '#8c193c',
                '#ebebe6',
                '#5a0037',
                '#e8ebed',
                '#d2d2d7'
            ]
        }
    ];

    constructor(
        private uiSrv:          UiService,
        private formatSrv:      FormatService,
        private changeDetector: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.update();
        this.colors = [];
    }
    ngOnChanges () {
        this.update();
        this.colors = this._colors;
    }

    ngAfterViewInit () {
      this.colors = this._colors;
      // for no error ExpressionChangedAfterItHasBeenCheckedError
      this.changeDetector.detectChanges();
    }

    private update () {
        var datas = this.graph.datas
            .filter(data => data.value != 0)
            .sort((a, b) => b.value - a.value);
        if (datas.length > 11) {
            var other = new MonitoringResultData();
            other.label = this.uiSrv.translate('monitoring.graphs.others.shortLabel');
            other.value = datas.slice(10).reduce((sum, current) => sum + current.value, 0);
            datas = datas.slice(0, 9);
            datas.push(other);
        }

        this.labels = datas.map(i => i.label);
        this.values = datas.map(i => i.value);

        if (this.graph.format === 'percent') {
            const sum = this.values.reduce((a, b) => a + b, 0);
            if (sum === 0) {
                this.values = [];
            } else {
                this.values = this.values.map(i => i / sum);
            }
        }
    }

}
